import { data } from 'vfile'
import setupAxios from './Base'
const prefix = '/_api_'

const API_URL = process.env.VUE_APP_API_URL


export default class Marketing {
  constructor(token) {
    this.axios = setupAxios({
      authorization: `Bearer ${token.token}`,
      cache: true,
      wedId: token.token_payload.wed_id,
    })

    this.wedId = token.token_payload.wed_id
  }

  getMarketingOrigin() {
    return this.axios
      .get(`${prefix}/getMarketingOrigin?wed=${this.wedId}`, {
        id: 'marketing-origin',
      })
      .then((response) => response.data)
  }

  addAnalyticsActivity({ wed_id, target, activity }) {
    return this.axios.post(`${API_URL}/v1/analytics/activity`,  {
        'wed_id': wed_id,
        'source': 'wedsite',
        'target': target,
        'activity': activity
      })
  }
}
